import { Controller } from "stimulus";
import Impetus from "impetus";

const CLASS_IS_LOCKED = "is-locked";
const CLASS_SECTION_WRAPPER_WITH_BUTTON = "section-wrapper--with-button";
const NUMBER_OF_ROWS_TO_LIMIT = 6;

export default class extends Controller {
    static targets = ["table", "scroller", "button", "header", "row"];

    connect() {
        window.addEventListener("load", this.handleLoad);
        window.addEventListener("touchstart", this.handleTouch);

        this.productTable = new Impetus({
            source: this.scrollerTarget,
            update: this.setScroll
        });

        this.tableTarget.addEventListener("mousedown", this.preventDefault);
        this.scrollerTarget.addEventListener("scroll", this.handleScroll);
    }

    disconnect() {
        window.removeEventListener("load", this.handleLoad);
        window.removeEventListener("touchstart", this.handleTouch);

        this.productTable = this.productTable.destroy();

        this.tableTarget.removeEventListener("mousedown", this.preventDefault);
        this.scrollerTarget.removeEventListener("scroll", this.handleScroll);
    }

    handleTouch = () => {
        this.productTable = this.productTable.destroy();

        window.removeEventListener("touchstart", this.handleTouch);
    };

    preventDefault = event => {
        event.preventDefault();
    };

    handleLoad = () => {
        if (this.rowTargets.length > NUMBER_OF_ROWS_TO_LIMIT) {
            this.lock();
        } else {
            this.release();
        }
    };

    handleScroll = () => {
        const { scrollLeft } = this.scrollerTarget;
        this.productTable.setValues(-scrollLeft);
    };

    setScroll = x => {
        this.scrollerTarget.scrollLeft = -x;
    };

    lock = () => {
        const headerHeight = this.headerTarget.offsetHeight;
        const rowHeight = this.rowTargets[0].offsetHeight;

        this.scrollerTarget.style.overflowY = "hidden";
        this.scrollerTarget.style.maxHeight = `${rowHeight *
            (NUMBER_OF_ROWS_TO_LIMIT + 0.5) +
            headerHeight}px`;

        this.element.classList.add(CLASS_SECTION_WRAPPER_WITH_BUTTON);
        this.buttonTarget.parentElement.classList.add(CLASS_IS_LOCKED);
    };

    release = () => {
        this.scrollerTarget.style.overflowY = "";
        this.scrollerTarget.style.maxHeight = "";

        this.element.classList.remove(CLASS_SECTION_WRAPPER_WITH_BUTTON);
        this.buttonTarget.parentElement.classList.remove(CLASS_IS_LOCKED);
    };
}



// WEBPACK FOOTER //
// ./public/assets/scripts/controllers/our-products_controller.js